import React from 'react';
import './PoweredByCinch.css';

// CIN-6441 (P2): platform-provider disclosure. Google's Place Actions policy
// requires the booking page to clearly denote that it is owned and operated by a
// platform provider. Small, unobtrusive, always-visible plain-text element
// rendered inside the modal chrome on every step. No external asset fetch.
const PoweredByCinch = () => (
  <div className="powered-by-cinch" data-testid="powered-by-cinch">
    Powered by Cinch
  </div>
);

export default PoweredByCinch;
